/** Media queries designed for writing mobile-first css:
 *  1. write styles for mobile
 *  2. using below listed media queries adjust tablet / desktop styles
 */

export const breakpoints = {
  tablet: `(min-width: 768px)`,
  desktop: '(min-width: 1024px)',
}

export const media = {
  tablet: `@media ${breakpoints.tablet}`,
  desktop: `@media ${breakpoints.desktop}`,
}
